import React, { useState } from "react";
import { Modal, Button } from "antd";
import { FaTrash } from "react-icons/fa";
import "./DeleteModal.scss";

const DeleteModal = (props) => {
    const [isModalVisible, setIsModalVisible] = useState(true);
    const [loading, setLoading] = useState(false);

    const closeModal = () => {
        setIsModalVisible(false);
        setTimeout(() => {
        props.closeDltModal();
        setIsModalVisible(false);
        }, 500);
    };

    const modalDelete = () => {
        setLoading(true);
        props.delete();
        setLoading(false);
        closeModal();
    };

    return (
        <div className="delete-modal-wrapper">
            <Modal
                footer={null}
                centered
                visible={isModalVisible}
                className="delete-modal-content"
            >
                <i className="dlt-icon">
                <FaTrash />
                </i>
                <h2 className="delete-headline">حذف {props.name}</h2>
                <p className="delete-p">هل انت متاكد من حذف {props.name} ؟</p>

                <div className="btns-action">
                <Button
                    type="primary"
                    size="large"
                    className="red-btn ml-20"
                    loading={loading}
                    onClick={modalDelete}
                >
                    حذف
                </Button>
                <Button
                    type="primary"
                    size="large"
                    className="solid-btn"
                    onClick={closeModal}
                >
                    الغاء
                </Button>
                </div>
            </Modal>
        </div>
    );
};
export default DeleteModal;
